"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("./common");
const any_1 = require("./any");
function getFunctionSchemaModifierProviders(getJoi) {
    const result = Object.assign(Object.assign({}, any_1.getAnySchemaModifierProviders(getJoi)), { arity: (argumentCount) => ({ schema }) => schema.arity(argumentCount), maxArity: (maxArgumentCount) => ({ schema }) => schema.maxArity(maxArgumentCount), minArity: (minArgumentCount) => ({ schema }) => schema.minArity(minArgumentCount) });
    return result;
}
exports.getFunctionSchemaModifierProviders = getFunctionSchemaModifierProviders;
exports.createFunctionPropertyDecorator = (joifulOptions) => (common_1.createPropertyDecorator()(({ joi }) => joi.func(), getFunctionSchemaModifierProviders, joifulOptions));
//# sourceMappingURL=function.js.map